import type { SVGProps } from 'react';

const SvgWifiOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="m21 11 2-2c-3.73-3.73-8.87-5.15-13.7-4.31l2.58 2.58c3.3-.02 6.61 1.22 9.12 3.73M9 17l3 3 3-3a4.237 4.237 0 0 0-6 0m10-4a9.9 9.9 0 0 0-3.72-2.33l3.02 3.02zM3.41 1.64 2 3.05 5.05 6.1C3.59 6.83 2.22 7.79 1 9l2 2c1.23-1.23 2.65-2.16 4.17-2.78l2.24 2.24A9.8 9.8 0 0 0 5 13l2 2a7 7 0 0 1 4.89-2.06l7.08 7.08 1.41-1.41z" />
  </svg>
);
export default SvgWifiOff;
